import React, { useEffect, useState } from 'react';
import { BellRing } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { AlertFields, describe, toBody, toForm } from '../portal/pages/WalletAlertCard';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/portal/users`;
const err = (e) => (typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : 'Errore');

export default function AdminWalletAlert({ user, headers }) {
  const [open, setOpen] = useState(false);
  const [st, setSt] = useState(null);
  const [form, setForm] = useState(null);
  useEffect(() => { if (open) axios.get(`${API}/${user.id}/wallet-alert`, { headers }).then((r) => { setSt(r.data); setForm(toForm(r.data)); }); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  const save = async () => {
    try { const { data } = await axios.put(`${API}/${user.id}/wallet-alert`, toBody(form), { headers }); setSt(data); setForm(toForm(data)); toast.success('Avviso plafond salvato'); }
    catch (e) { toast.error(err(e)); }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} className="block mt-1 text-xs text-[#D4AF37] flex items-center gap-1" data-testid={`admin-wallet-alert-${user.id}`}><BellRing size={12} />Avviso plafond</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#0B0D10] border-[#1F242C] text-white" data-testid="admin-wallet-alert-dialog">
          <DialogHeader><DialogTitle>Avviso plafond · {user.email}</DialogTitle></DialogHeader>
          {form && <>
            <AlertFields value={form} onChange={setForm} inputClass="bg-[#050505] border-[#1F242C] text-white rounded-sm" testPrefix="admin-alert" />
            <p className="text-xs text-[#8A8F97]" data-testid="admin-alert-threshold">{describe(st)}</p>
            <Button onClick={save} className="bg-[#D4AF37] text-black rounded-sm" data-testid="admin-alert-save">Salva</Button>
          </>}
        </DialogContent>
      </Dialog>
    </>
  );
}
